import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import { ArrowDown } from "@element-plus/icons-vue";
import { List, EditPen, Loading, Timer } from "@element-plus/icons-vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { audioUrl } from "@/env.js";
import { reactive, ref, nextTick, watch, computed, onBeforeUnmount } from "vue";
import Recorder from "@/components/exam/Recorder-Player.vue";
import { GetResumeApi, SetResumeApi } from "@/api/examApi.js";
import { SaveResultApi, SubmitExamApi } from "@/api/oralApi.js";
import { ElLoading, ElMessage, ElMessageBox } from "element-plus";
import SelfEvaluation from "@/components/exam/SelfEvaluation.vue";
let examId = "";
let route;
let router;
export default {
  components: {
    Recorder,
    SelfEvaluation
  },
  props: ["examInfo"],
  setup(props, content) {
    let paperInfo = reactive({});
    let itemNo = ref(0);
    let taskNo = ref(0);
    let cache = reactive({});
    let totalQuestion = ref(0);
    //0未播放导语，1播放导语中，2播放结束开始倒计时，3录音中，4录音结束
    let questStatus = ref(0);
    let step = ref(0);
    let store = useStore();
    let downBottom = ref(false);
    examId = props.examInfo.examId + "";
    route = useRoute();
    router = useRouter();
    //步骤控制
    function changeStep() {
      step.value++;
      //（开始倒计时）
      if (step.value == 1) {
        setCountDown();
        setAudioType();
        setcache();
        let setLoading = function () {
          nextTick(() => {
            let audio = document.getElementById("audio");
            let question_audio = document.getElementById("question_audio");
            if (audio && audio.children[0].src) {
              if (question_audio) {
                question_audio.load();
              }
              audio.load();
            } else {
              setTimeout(() => {
                setLoading();
              }, 1000);
            }
          });
        };
        setLoading();
      }
      //考试结束
      else if (step.value == 4) {
        content.emit("finishExam");
      }
    }
    //试卷
    let {
      getPaper
    } = usePaper(paperInfo, totalQuestion, props.examInfo);
    //缓存
    let {
      getResume,
      setAnswer,
      setcache
    } = useAnswer(cache, getPaper, props.examInfo, itemNo, step, taskNo, content);
    //流程
    let {
      timeText,
      setCountDown,
      finishExam
    } = useExamProcess(props.examInfo, content, cache, setcache, totalQuestion, paperInfo, changeStep);
    function clearText(text) {
      let getStr = text;
      for (let i = 0;; i++) {
        if (getStr.indexOf("{{") == -1) break;
        getStr = getStr.substring(0, getStr.indexOf("{{")) + getStr.substr(getStr.indexOf("}}") + 2);
      }
      return getStr.replace(/&nbsp;/g, "");
    }
    //播放录音功能
    let {
      setAudioType,
      record_switch,
      stop_switch,
      recording,
      setScores,
      audioCanPlay,
      audioEnded,
      recordTime,
      prepareTime,
      totPrepareTime,
      recordingTime,
      stopRecord,
      coreType,
      qType,
      changeTask,
      finishExamInStep2
    } = useAudio(paperInfo, itemNo, cache, questStatus, step, store, taskNo, downBottom, finishExam);
    function nextQuestion() {
      if (step.value == 1 && taskNo.value == 6) {
        finishExam(3);
      } else if (step.value == 2 && itemNo.value == paperInfo.items.length - 1) {
        finishExam(1);
      } else if (step.value == 1 && itemNo.value == 1 && taskNo.value < 7) {
        taskNo.value++;
        changeTask();
        setcache();
      } else {
        itemNo.value++;
        setcache();
      }
    }
    getResume(setCountDown, setAudioType, finishExamInStep2);
    //滚动
    function scrollMove() {
      document.getElementsByClassName("question-text")[0].scrollTop += 300;
    }
    return {
      finishExamInStep2,
      downBottom,
      scrollMove,
      nextQuestion,
      setcache,
      coreType,
      qType,
      stopRecord,
      recordingTime,
      prepareTime,
      totPrepareTime,
      recordTime,
      clearText,
      taskNo,
      step,
      List,
      EditPen,
      store,
      record_switch,
      stop_switch,
      recording,
      setScores,
      changeStep,
      questStatus,
      Timer,
      timeText,
      finishExam,
      audioUrl,
      itemNo,
      paperInfo,
      cache,
      setAnswer,
      getPaper,
      audioCanPlay,
      audioEnded,
      Loading,
      ArrowDown
    };
  }
};
//流程控制(倒计时，交卷)
function useExamProcess(examInfo, content, cache, setcache, totalQuestion, paperInfo, changeStep) {
  let countDownTimer;
  let countTimer;
  let timeText = ref("00:00:00");
  onBeforeUnmount(() => {
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    if (countTimer) clearInterval(countTimer);
  });
  //启动倒计时
  function setCountDown() {
    let time = cache.remaining || examInfo.remainingTime;
    //计时器
    countDownTimer = new WebSocket("wss://unilearn.fltrp.com/jzws/count-down");
    countDownTimer.onopen = () => {
      countDownTimer.send(time + ":1:" + examInfo.userId);
    };
    countDownTimer.onmessage = evt => {
      time = evt.data;
      if (time <= 0) {
        finishExam(2);
      } else {
        let s = time % 60;
        let m = parseInt(time / 60) % 60;
        let h = parseInt(parseInt(time / 60) / 60);
        timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${s > 9 ? s : "0" + s}`;
        cache.remaining = time;
        //倒计时提示
        if (time == 300) {
          ElMessage({
            type: "warning",
            showClose: true,
            message: "距离考试结束仅有5分钟"
          });
        }
      }
    };
    countDownTimer.onclose = e => {
      if (!e.wasClean && window.navigator.onLine && countDownTimer && countDownTimer.readyState != 0) {
        countDownTimer.close();
        setCountDown();
      }
    };
  }
  // function setCountDown() {
  //   let time = cache.remaining || examInfo.remainingTime;
  //   //计时器
  //   countTimer = setInterval(() => {
  //     time--;
  //     if (time <= 0) {
  //       finishExam(2);
  //     } else {
  //       let s = time % 60;
  //       let m = parseInt(time / 60) % 60;
  //       let h = parseInt(parseInt(time / 60) / 60);
  //       timeText.value = `${h > 9 ? h : "0" + h}:${m > 9 ? m : "0" + m}:${
  //         s > 9 ? s : "0" + s
  //       }`;
  //       cache.remaining = time;
  //       //倒计时提示
  //       if (time == 300) {
  //         ElMessage({
  //           type: "warning",
  //           showClose: true,
  //           message: "距离考试结束仅有5分钟",
  //         });
  //       }
  //     }
  //   }, 1000);
  // }
  //倒计时验证

  //交卷(1手动交卷 2倒计时结束被交卷 3提交分卷)
  function finishExam(type) {
    if (type == 1) {
      //前置判断
      ElMessageBox.confirm(`确认交卷吗？`, "", {
        showClose: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        finishExamApi(1);
      });
    } else if (type == 2) {
      finishExamApi(2);
    } else if (type == 3) {
      finishExamApi(3);
    }
  }
  function finishExamApi(submit) {
    if (countTimer) clearInterval(countTimer);
    if (countDownTimer) countDownTimer.close();
    countDownTimer = null;
    let data = {
      examId,
      subdivide: examInfo.subdivide,
      paperId: paperInfo.paperId,
      remaining: cache.remaining
    };
    const loading = ElLoading.service({
      lock: true,
      text: "正在提交考试..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    if (examInfo.examType == 3 && submit == 3) {
      changeStep();
      setcache(true);
      return 0;
    }
    SubmitExamApi({
      ...data
    }).then(r => {
      if (r.status < 400) {
        if (submit == 3) {
          loading.close();
          content.emit("finishExam", {
            ...r.data
          });
        } else if (submit == 2 && examInfo.subdivide == 2 && examInfo.examType != 3) {
          let data = {
            remaining: cache.remaining,
            examId: r.data.examId,
            subdivide: r.data.subdivide,
            paperId: r.data.papers[0].paperId
          };
          SubmitExamApi({
            ...data
          }).then(r => {
            if (r.status < 400) {
              ElMessage({
                type: "success",
                showClose: true,
                message: "提交成功"
              });
              setTimeout(() => {
                loading.close();
                content.emit("finishExam");
              }, 1000);
            } else {
              loading.close();
              ElMessage({
                type: "error",
                showClose: true,
                message: r.msg
              });
            }
          });
        } else {
          loading.close();
          if (examInfo.examType == 3) {
            content.emit("finishExam");
          }
          //未能完成考试
          else if (cache.interruptMark.audioNum >= 3) {
            changeStep();
          } else {
            content.emit("finishExam");
          }
        }
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  return {
    timeText,
    setCountDown,
    finishExam
  };
}
//获取试卷
function usePaper(paperInfo, totalQuestion, examInfo) {
  //获取试卷
  function getPaper(id, setCountDown, setAudioType) {
    Object.assign(paperInfo, examInfo.papers[id]);
    totalQuestion.value = useSettingPaper(paperInfo, examInfo.subdivide);
    //倒计时
    setCountDown ? setCountDown() : "";
    setAudioType ? setAudioType() : "";
  }
  return {
    getPaper
  };
}
//目录
function useSettingPaper(paperInfo, subdivide) {
  let task = 1;
  let taskNo = 0;
  if (subdivide == 3) {
    if (window.localStorage.getItem("preTotalNo-" + (route.query.examid || route.query.examId))) {
      task += Number(window.localStorage.getItem("preTotalNo-" + (route.query.examid || route.query.examId)));
    }
  }
  paperInfo.items.forEach(items => {
    items.menu = task;
    items.questionGroupList.forEach(group => {
      group.questionList.forEach(questionItem => {
        if (questionItem.questionScore) {
          task++;
          taskNo++;
        }
      });
    });
    //mm的分类
    if (items.questionGroupList[0].questionMethod == "mm") {
      //选择题展示
      if (items.questionGroupList[0].questionList[0].questionStem.split(" ").length > 2) {
        items.questionGroupList[0].questionMethod = "mm-mcq";
      } else if (items.questionGroupList[0].choiceList[0].choiceText.split(" ").length > 1) {
        items.questionGroupList[0].questionMethod = "mm-drag";
      }
    }
  });
  return taskNo;
}
//缓存 答案
function useAnswer(cache, getPaper, examInfo, itemNo, step, taskNo, content) {
  let setCacheTime = null;
  //获取缓存
  function getResume(setCountDown, setAudioType, finishExamInStep2) {
    const loading = ElLoading.service({
      lock: true,
      text: "获取作答数据..",
      background: "rgba(0, 0, 0, 0.7)"
    });
    GetResumeApi(examId).then(r => {
      loading.close();
      if (r.status < 400) {
        Object.assign(cache, r.data);
        //题号
        if (cache.interruptMark) {
          cache.interruptMark = JSON.parse(cache.interruptMark);
          itemNo.value = cache.interruptMark.itemNo || 0;
          taskNo.value = cache.interruptMark.taskNo || 0;
          step.value = cache.interruptMark.step || 0;
        } else if (examInfo.examType == 3) {
          step.value = 1;
          cache.interruptMark = {};
        } else if (examInfo.subdivide == 3) {
          step.value = 2;
          cache.interruptMark = {};
        } else {
          cache.interruptMark = {};
        }

        //步骤
        if (step.value == 0) {
          getPaper(0);
        } else {
          if (examInfo.examType == 3) {
            if (step.value == 1) {
              getPaper(0, setCountDown, setAudioType, finishExamInStep2);
            } else {
              getPaper(1, setCountDown, setAudioType, finishExamInStep2);
            }
          } else {
            getPaper(0, setCountDown, setAudioType, finishExamInStep2);
          }
        }
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  //设置答案
  function setAnswer(msg) {
    for (let key in msg) {
      cache.answers[key] = msg[key];
    }
  }
  //设置缓存
  function setcache(clear) {
    if (setCacheTime == cache.remaining) {
      return 0;
    } else {
      setCacheTime = cache.remaining;
    }
    let data = {
      answers: {
        ...cache.answers
      },
      audios: {
        ...cache.audios
      },
      remaining: cache.remaining,
      examId: examId,
      //题号
      interruptMark: {
        itemNo: clear ? 0 : itemNo.value,
        taskNo: clear ? 0 : taskNo.value,
        step: step.value,
        audioNum: cache.interruptMark ? cache.interruptMark.audioNum || 0 : 0
      }
    };
    SetResumeApi(data).then(r => {
      // if (r.status == 404) {
      //   ElMessage({
      //     type: "error",
      //     showClose: true,
      //     message: "您的考试已被强制提交。",
      //   });
      //   content.emit("finishExam");
      // } else
      if (r.status == 406) {
        ElMessage({
          type: "error",
          showClose: true,
          message: "您的考试已被重置。"
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else if (r.status == 403) {
        ElMessage({
          type: "error",
          showClose: true,
          message: "您的登录已失效或在别处登录"
        });
        setTimeout(() => {
          window.closed();
        }, 2000);
      } else if (clear) {
        content.emit("finishExam", {
          ...examInfo
        });
      }
    });
  }
  return {
    setAnswer,
    setcache,
    getResume
  };
}
//播放录音器
function useAudio(paperInfo, itemNo, cache, questStatus, step, store, taskNo, downBottom, finishExam) {
  let record_switch = ref(false);
  let stop_switch = ref(false);
  let timer;
  let loading;
  let prepareTime = ref(0);
  let totPrepareTime = ref(0);
  let recordingTime = ref(0);
  let coreType = ref("");
  let qType = ref("");
  let finishFlag = false;
  let recordTime = computed(() => {
    let time = 0;
    if (paperInfo.items[itemNo.value]) {
      paperInfo.items[itemNo.value].itemAttributeList.some(item => {
        if (item.itemAttributeName.indexOf("要求作答") != -1) {
          time = item.itemAttributeValue * 1;
          return true;
        }
      });
    }
    return time;
  });
  //播放结束
  function audioEnded(isQuestion) {
    if (!isQuestion) {
      if (paperInfo.items[itemNo.value].questionGroupList.length > 1 || paperInfo.items[itemNo.value].subskill == "retell") {
        let audio = document.getElementById("question_audio");
        audio.play();
        return 0;
      }
    }
    questStatus.value = 2;
    paperInfo.items[itemNo.value].itemAttributeList.some(item => {
      if (item.itemAttributeName.indexOf("准备作答") != -1) {
        prepareTime.value = item.itemAttributeValue * 1;
        totPrepareTime.value = item.itemAttributeValue * 1;
        return true;
      }
    });
    //开始倒计时
    clearInterval(timer);
    timer = setInterval(() => {
      if (prepareTime.value <= 0) {
        clearInterval(timer);
        //倒计时结束 开始录音
        record_switch.value = !record_switch.value;
      } else {
        prepareTime.value = prepareTime.value - 1;
      }
    }, 1000);
  }
  //开始录音
  function recording() {
    questStatus.value = 3;
    recordingTime.value = recordTime.value;
    // 倒计时
    clearInterval(timer);
    timer = setInterval(() => {
      if (recordingTime.value <= 0) {
        clearInterval(timer);
        //倒计时结束
        stopRecord();
      } else {
        recordingTime.value--;
      }
    }, 1000);
  }
  //结束录音
  function stopRecord() {
    clearInterval(timer);
    questStatus.value = 4;
    stop_switch.value = !stop_switch.value;
    loading = ElLoading.service({
      lock: true,
      text: "保存作答..",
      background: "rgba(0, 0, 0, 0.7)"
    });
  }
  //获取分数
  function setScores(info) {
    SaveResultApi({
      recordId: info.recordId,
      examId,
      itemId: paperInfo.items[itemNo.value].itemId,
      paperId: paperInfo.paperId,
      audioUrl: info.audioUrl || "",
      questionId: paperInfo.items[itemNo.value].questionGroupList[taskNo.value].questionList[0].questionId,
      resultStr: info
    }).then(r => {
      loading.close();
      if (r.status == 200) {
        loading.close();
        if (step.value == 2) {
          cache.interruptMark.audioNum = cache.interruptMark && cache.interruptMark.audioNum ? cache.interruptMark.audioNum + 1 : 1;
        }
        if (finishFlag) finishExam(2);
        finishFlag = false;
      } else {
        ElMessage({
          type: "error",
          showClose: true,
          message: r.msg
        });
      }
    });
  }
  //音频加载完成
  function audioCanPlay() {
    questStatus.value = 1;
    let audio = document.getElementById("audio");
    audio.play();
  }
  //失败
  function recorderDefeat() {
    ElMessage({
      type: "error",
      showClose: true,
      message: "发生错误"
    });
    router.back();
  }
  //设置其他值
  function setAudioType() {
    if (step.value == 1) {
      // 定级卷
      coreType.value = store.state.eval.CORE_TYPE_PARA;
      if (itemNo.value == 1) {
        coreType.value = store.state.eval.CORE_TYPE_SENT;
      } else if (itemNo.value == 2) {
        qType.value = 4;
        coreType.value = store.state.eval.CORE_TYPE_OPEN;
      }
    } else if (step.value == 2) {
      // 诊断卷
      if (itemNo.value == 0) {
        // 朗读题
        coreType.value = store.state.eval.CORE_TYPE_PARA;
      } else {
        // 主观题答案参考 关键词
        coreType.value = store.state.eval.CORE_TYPE_OPEN;
        if (paperInfo.items[itemNo.value].itemName.indexOf("image") != -1) {
          qType.value = 5;
        } else if (paperInfo.items[itemNo.value].itemName.indexOf("talk") != -1 || paperInfo.items[itemNo.value].itemName.indexOf("speech") != -1 || paperInfo.items[itemNo.value].itemName.indexOf("presentation") != -1) {
          qType.value = 7;
        } else {
          qType.value = 4;
        }
      }
    }
  }
  //更换题目时，更新播放状态
  function changeTask() {
    clearInterval(timer);
    questStatus.value = 0;
    let question_audio = document.getElementById("question_audio");
    question_audio.load();
    question_audio.play();
    questStatus.value = 1;
  }
  //主动交卷
  function finishExamInStep2(timeout) {
    if (timeout) {
      if (questStatus.value == 3) {
        finishFlag = true;
        stopRecord();
      } else {
        finishExam(2);
      }
      return 0;
    }
    ElMessageBox.confirm(`确认提前提交诊断卷吗？`, "", {
      showClose: false,
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      if (questStatus.value == 3) {
        finishFlag = true;
        stopRecord();
      } else {
        finishExam(2);
      }
    }).catch(() => {});
  }
  watch(itemNo, () => {
    clearInterval(timer);
    nextTick(() => {
      questStatus.value = 0;
      setLoading();
      setAudioType();
    });
  }, {
    immediate: true
  });
  function setLoading() {
    let audio = document.getElementById("audio");
    let question_audio = document.getElementById("question_audio");
    if (audio) {
      question_audio ? question_audio.pause() : "";
      question_audio ? question_audio.load() : "";
      audio.pause();
      audio.load();
      downBottom.value = document.getElementsByClassName("question-text")[0] ? document.getElementsByClassName("question-text")[0].scrollHeight > document.getElementsByClassName("question-text")[0].offsetHeight : false;
    } else {
      setTimeout(() => {
        setLoading();
      }, 1000);
    }
  }
  return {
    finishExamInStep2,
    totPrepareTime,
    setAudioType,
    recorderDefeat,
    record_switch,
    stop_switch,
    recording,
    setScores,
    audioCanPlay,
    audioEnded,
    recordTime,
    prepareTime,
    recordingTime,
    stopRecord,
    coreType,
    qType,
    changeTask
  };
}